import script from "./GlocareBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./GlocareBanner.vue?vue&type=script&setup=true&lang=js"

import "./GlocareBanner.vue?vue&type=style&index=0&id=10760cc4&scoped=true&lang=scss"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10760cc4"]])

export default __exports__